/* ============================================
   QN-NEW TESTIMONIALS JS
   Carrusel de testimonios
   ============================================ */

(function() {
  'use strict';

  const QNTestimonials = {
    init: function() {
      this.carousels = document.querySelectorAll('[data-testimonials-carousel]');

      this.carousels.forEach((carousel) => {
        this.initCarousel(carousel);
      });
    },

    initCarousel: function(carousel) {
      const track = carousel.querySelector('[data-testimonials-track]');
      const dots = carousel.querySelectorAll('[data-testimonials-dot]');
      const slides = track ? track.querySelectorAll('.qn-testimonials__slide') : [];

      if (!track || !slides.length || !dots.length) return;

      const getSlideStep = () => {
        const firstSlide = slides[0];
        if (!firstSlide) return 0;

        const slideStyles = window.getComputedStyle(firstSlide);
        const trackStyles = window.getComputedStyle(track);

        const slideWidth = firstSlide.getBoundingClientRect().width;
        const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || slideStyles.marginRight || 0);

        return slideWidth + gap;
      };

      const getActiveIndex = () => {
        const slideStep = getSlideStep();
        if (!slideStep) return 0;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / slideStep)));
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slideStep = getSlideStep();
          track.scrollTo({
            left: slideStep * index,
            behavior: 'smooth'
          });
          this.updateActiveDot(dots, index);
        });
      });

      let scrollTimeout;
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(() => {
          this.updateActiveDot(dots, getActiveIndex());
        }, 60);
      }, { passive: true });

      let autoplayInterval;

      const startAutoplay = () => {
        stopAutoplay();

        autoplayInterval = window.setInterval(() => {
          const slideStep = getSlideStep();
          if (!slideStep) return;

          const activeIndex = getActiveIndex();
          const nextIndex = activeIndex >= slides.length - 1 ? 0 : activeIndex + 1;

          track.scrollTo({
            left: slideStep * nextIndex,
            behavior: 'smooth'
          });

          this.updateActiveDot(dots, nextIndex);
        }, 5000);
      };

      const stopAutoplay = () => {
        if (autoplayInterval) {
          window.clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      };

      startAutoplay();

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);

      window.addEventListener('resize', () => {
        this.updateActiveDot(dots, getActiveIndex());
      });
    },

    updateActiveDot: function(dots, activeIndex) {
      dots.forEach((dot, index) => {
        dot.classList.toggle('qn-testimonials__dot--active', index === activeIndex);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => QNTestimonials.init());
  } else {
    QNTestimonials.init();
  }

  window.QNTestimonials = QNTestimonials;
})();